import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Category as SchemaCategory } from '../schemas/Category';
import { type ChangedCategory as SchemaChangedCategory } from '../schemas/ChangedCategory';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Update categories display sequence, parent category and is_hidden_in_menu
 * @tags Categories
 */
export const BatchUpdateCategoriesContentType = 'application/json' as const;
export type BatchUpdateCategoriesRequest = SchemaChangedCategory[];
export type BatchUpdateCategoriesResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCategory[];
    };
    /**
     * @description No content
     */
    '204': {
        'application/json': unknown;
    };
};
export type BatchUpdateCategoriesResponseSuccess = BatchUpdateCategoriesResponses['200']['application/json'];
export type BatchUpdateCategoriesSearchParams = undefined;
export type BatchUpdateCategoriesPathParameters = undefined;
export const BatchUpdateCategoriesUrl = '/categories' as const;
export const BatchUpdateCategoriesMethod = 'PATCH' as const;
export const getBatchUpdateCategoriesUrl = (_params?: BatchUpdateCategoriesPathParameters) => BatchUpdateCategoriesUrl;
